import { useEffect, useRef, useState } from 'react';

export default function useWebsocketChat(wsUrl, initialSessionId = null) {
  const wsRef = useRef(null);
  const [sessionId, setSessionId] = useState(initialSessionId);
  const [messages, setMessages] = useState([]);
  const [partial, setPartial] = useState('');
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    const ws = new WebSocket(wsUrl);
    wsRef.current = ws;

    ws.onopen = () => {
      setConnected(true);
      ws.send(JSON.stringify({ type: 'start', session_id: initialSessionId }));
    };

    ws.onmessage = (ev) => {
      try {
        const msg = JSON.parse(ev.data);
        if (msg.type === 'session') {
          setSessionId(msg.session_id);
        } else if (msg.type === 'token') {
          setPartial(p => p + msg.data);
        } else if (msg.type === 'done') {
          setMessages(m => [...m, { role: 'assistant', text: msg.full_text }]);
          setPartial('');
        } else if (msg.type === 'error') {
          console.error('WS error:', msg.message);
        }
      } catch (err) {
        console.error('parse ws msg', err);
      }
    };

    ws.onclose = () => setConnected(false);
    ws.onerror = (e) => console.error('ws err', e);

    return () => {
      ws.close();
    };
  }, [wsUrl]);

  function sendPrompt(prompt) {
    if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) {
      console.warn('WebSocket not connected');
      return;
    }
    setMessages(m => [...m, { role: 'user', text: prompt }]);
    wsRef.current.send(JSON.stringify({ type: 'prompt', prompt, session_id: sessionId }));
  }

  return { connected, sessionId, messages, partial, sendPrompt };
}
